import { render } from "./AboutTeam.vue?vue&type=template&id=02005a72&scoped=true"
import script from "./AboutTeam.vue?vue&type=script&lang=js"
export * from "./AboutTeam.vue?vue&type=script&lang=js"

import "./AboutTeam.vue?vue&type=style&index=0&id=02005a72&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02005a72"]])

export default __exports__